import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  Inject,
  forwardRef,
  OnDestroy,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { CalculatedValueDataEntity } from '../../../../../models/data-entities';
import {
  WorkflowService,
  WorkflowContextService,
  SecurityService
} from '../../../../../services';
import { Subscription, interval } from 'rxjs';
import * as _ from 'lodash';
import { CalcOnChangeDataEntityComponent } from '../../data-entity-input/calc-on-change-data-entity';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-calculate-value-data-entity-input',
  templateUrl: './calculate-value-data-entity-input.component.html',
  styleUrls: ['./calculate-value-data-entity-input.component.css'],
  standalone: false
})
export class CalculateValueDataEntityInputComponent
  extends CalcOnChangeDataEntityComponent
  implements OnInit, OnDestroy {
  entity: CalculatedValueDataEntity;
  @Input() showLabel = true;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
  templateForPermitForm: boolean = false; // Added by Vipul on 19/12/2025

  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    ref: ChangeDetectorRef,
    @Inject(forwardRef(() => WorkflowService))
    workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    context: WorkflowContextService,
    @Inject(forwardRef(() => SecurityService))
    securitySvc: SecurityService
  ) {
    super(
      layoutService,
      componentFactoryResolver,
      workflowSvc,
      context,
      securitySvc,
      ref
    );
    // Started by Vipul on 19/12/2025
    layoutService.useNewLayout$.subscribe(useNewLayout => {
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 19/12/2025
  }

  async persistChildComponent() {
    this.entity.formulaValue = '';
    this.entity.formattedValue = '';
  }
}
